import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {RegisterCountryManufactureRoutingModule} from './register-country-manufacture-routing.module';
import {RegisterCountryManufactureComponent} from './register-country-manufacture.component';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AngularSvgIconModule} from "angular-svg-icon";
import {HttpClient} from "@angular/common/http";
import {HttpLoaderFactory} from "../../../app.module";
import {AppDataService} from "../../../service/app_data.service";
import {EventBusService} from "../../../service/event-bus.service";


@NgModule({
  declarations: [RegisterCountryManufactureComponent],
  imports: [
    CommonModule,
    RegisterCountryManufactureRoutingModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    FormsModule,
    AngularSvgIconModule.forRoot()
  ],
  providers: [
    TranslateService,
    AppDataService,
    EventBusService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RegisterCountryManufactureModule { }
